<div class="file-upload-container">
  <div
    class="drop-zone"
    [class.dragging]="isDragging()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <mat-icon class="upload-icon">cloud_upload</mat-icon>

    <p class="upload-text">
      {{ 'fileUpload.dragDrop' | translate }}
    </p>

    <p class="upload-text-secondary">
      {{ 'fileUpload.or' | translate }}
    </p>

    <input
      #fileInput
      type="file"
      [accept]="acceptAttribute"
      [multiple]="multiple()"
      (change)="onFileSelected($event)"
      style="display: none"
    />

    <button mat-raised-button color="primary" (click)="fileInput.click()" type="button">
      <mat-icon>folder_open</mat-icon>
      {{ 'fileUpload.selectFile' | translate }}
    </button>

    @if (maxFileSizeMB()) {
      <div class="file-info">
        <small> {{ 'fileUpload.maxSize' | translate }}: {{ maxFileSizeMB() }} MB </small>
      </div>
    }
  </div>

  @if (errorMessage()) {
    <div class="error-message">
      <mat-icon color="warn">error</mat-icon>
      <span>{{ errorMessage() | translate: { maxSize: maxFileSizeMB() } }}</span>
    </div>
  }

  @if (selectedFiles().length > 0 && !hideSelectedFiles()) {
    <div class="selected-files">
      <h4>{{ 'fileUpload.selectedFiles' | translate }}</h4>
      <div class="file-list">
        @for (file of selectedFiles(); track file.name + file.size; let i = $index) {
          <div class="file-item">
            <mat-icon class="file-icon">insert_drive_file</mat-icon>
            <div class="file-details">
              <span class="file-name">{{ file.name }}</span>
              <span class="file-size">{{ formatFileSize(file.size) }}</span>
            </div>
            <button mat-icon-button (click)="removeFile(i)" type="button" class="remove-button">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>
